var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "container-wrapper",
    class: {
      'background-registration': _vm.registrationShown,
      'background-approval': _vm.approvalShown,
      'background-profile': _vm.profileShown
    }
  }, [_vm.registrationShown ? _c('registration-self-employed') : _vm._e(), _vm.connectingShown ? _c('connecting-self-employed') : _vm._e(), _vm.approvalShown ? _c('approval-self-employed') : _vm._e(), _vm.profileShown ? _c('auto-declaration') : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }